import React, { Component } from 'react';
import img from '../../../assets/Admin/Finance_Content//955a75765d6671ab30bb11aca5e967eb_html_524f7a70a1afbc7c.png';
import img1 from '../../../assets/Admin/Finance_Content/955a75765d6671ab30bb11aca5e967eb_html_a8b485fdf00f066e.png';
class FinacecContent extends Component {
    render() {
        return (
            <div className="mi_main">
                                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
                <p ><b > Process Invoice:</b></p>
                <p>Admin process the invoice on monthly basis. Invoice is generated for the selected carrier, year and month. Brokers/Agencies matches the selection criteria gets the invoice the month and it will be available in Agency/Broker Our Book.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
            </div>
        )
    }
}
export default FinacecContent;
